<img [src]="src" alt="Image" />